import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "./private_uploads"

import Alpine from "alpinejs"
import persist from "@alpinejs/persist"

Alpine.plugin(persist)
window.Alpine = Alpine

document.addEventListener("turbo:before-cache", () => Alpine.destroyTree(document.body))
document.addEventListener("turbo:load", () => Alpine.initTree(document.body))

Alpine.start()

// After a failed form submission, move focus to the error summary (WCAG focus management).
document.addEventListener("turbo:render", () => document.querySelector("[data-autofocus]")?.focus())
document.addEventListener("turbo:load", () => document.querySelector("[data-autofocus]")?.focus())
